"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokingSlipDataDto = exports.BrokingSlipFormDataDto = exports.BrokingSlipFormDataCommentsDto = exports.BrokingSlipDocumentsDto = exports.BrokingSlipVersionDetailsDtoWithId = exports.BrokingSlipVersionDetailsDto = exports.BrokingSlipVersionFormData = exports.BrokingSlipVersionData = exports.BrokingSlipVersionMappedCoverDto = exports.PreferredTpaDetailsDto = exports.PreferredInsurerDetailsDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class PreferredInsurerDetailsDto {
}
exports.PreferredInsurerDetailsDto = PreferredInsurerDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Location Id of Insurer", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "Location Id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], PreferredInsurerDetailsDto.prototype, "locationId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Branch Id of the Insurer", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "Branch Id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], PreferredInsurerDetailsDto.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Insurer Id", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "Insurer Id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], PreferredInsurerDetailsDto.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Contact id of Insurer", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "Contact Id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], PreferredInsurerDetailsDto.prototype, "contactId", void 0);
class PreferredTpaDetailsDto {
}
exports.PreferredTpaDetailsDto = PreferredTpaDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Location Id of TPA", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "location Id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], PreferredTpaDetailsDto.prototype, "locationId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Branch Id of the TPA", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "branch Id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], PreferredTpaDetailsDto.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "TPA Id", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "tpa Id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], PreferredTpaDetailsDto.prototype, "tpaId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({ description: "Contact id of TPA", example: 1 }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "contact Id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], PreferredTpaDetailsDto.prototype, "contactId", void 0);
class BrokingSlipVersionMappedCoverDto {
}
exports.BrokingSlipVersionMappedCoverDto = BrokingSlipVersionMappedCoverDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Cover Id", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionMappedCoverDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Opportunity Id", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "opportunity Id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionMappedCoverDto.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Cover Map Id", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "cover map Id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionMappedCoverDto.prototype, "coverMapId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Policy Type Id", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "policy type Id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionMappedCoverDto.prototype, "policyTypeId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Broking Slip version Id", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "broking slip version id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionMappedCoverDto.prototype, "brokingSlipVersionId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Name of the cover mapped.",
        example: "Name of the cover",
    }),
    (0, class_validator_1.IsString)({ message: "cover name must be a string." }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionMappedCoverDto.prototype, "coverName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Response of the cover mapped.",
        example: "Response of the cover",
    }),
    (0, class_validator_1.IsString)({ message: "cover response must be a string." }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionMappedCoverDto.prototype, "coverResponse", void 0);
class BrokingSlipVersionData {
}
exports.BrokingSlipVersionData = BrokingSlipVersionData;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Sum insured", example: 100000 }),
    (0, class_validator_1.IsInt)({ message: "sum insured must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionData.prototype, "sumInsured", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Brokerage precentage", example: 1 }),
    (0, class_validator_1.IsString)({ message: "brokerage percentage must be a string." }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionData.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "policy start date", example: "2025-12-10" }),
    (0, class_validator_1.IsString)({ message: "policy from must be a string." }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionData.prototype, "policyFrom", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "policy end date", example: "2025-12-10" }),
    (0, class_validator_1.IsString)({ message: "policy to must be a string." }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionData.prototype, "policyTo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "policy renewal date", example: "2025-12-10" }),
    (0, class_validator_1.IsString)({ message: "policy renewal date must be a string." }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionData.prototype, "renewalDate", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Quote receipt timeline", example: "2025-12-10" }),
    (0, class_validator_1.IsString)({ message: "quote receipt timeline must be a string." }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionData.prototype, "quoteReceiptTimeline", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Business Activity", example: "Manufacturing" }),
    (0, class_validator_1.IsString)({ message: "business activity must be a string." }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionData.prototype, "businessActivity", void 0);
class BrokingSlipVersionFormData {
}
exports.BrokingSlipVersionFormData = BrokingSlipVersionFormData;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Broking slip version data",
        type: BrokingSlipVersionData,
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => BrokingSlipVersionData),
    tslib_1.__metadata("design:type", BrokingSlipVersionData)
], BrokingSlipVersionFormData.prototype, "versionDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Covers details",
    }),
    (0, class_validator_1.IsObject)({
        message: "CoversConfig must be an object with cover IDs as keys",
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], BrokingSlipVersionFormData.prototype, "coversConfig", void 0);
class BrokingSlipVersionDetailsDto {
}
exports.BrokingSlipVersionDetailsDto = BrokingSlipVersionDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Version Name", example: "Version 1" }),
    (0, class_validator_1.IsString)({ message: "Version name must be a string." }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionDetailsDto.prototype, "versionName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Broking slip version form data",
        type: BrokingSlipVersionFormData,
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => BrokingSlipVersionFormData),
    tslib_1.__metadata("design:type", BrokingSlipVersionFormData)
], BrokingSlipVersionDetailsDto.prototype, "formData", void 0);
class BrokingSlipVersionDetailsDtoWithId extends BrokingSlipVersionDetailsDto {
}
exports.BrokingSlipVersionDetailsDtoWithId = BrokingSlipVersionDetailsDtoWithId;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "version Id", example: 100000 }),
    (0, class_validator_1.IsInt)({ message: "version Id must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionDetailsDtoWithId.prototype, "versionId", void 0);
class BrokingSlipDocumentsDto {
}
exports.BrokingSlipDocumentsDto = BrokingSlipDocumentsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Document Type Lid", example: 100000 }),
    (0, class_validator_1.IsInt)({ message: "Document Type Lid must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipDocumentsDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Document Id", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "Document Id must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipDocumentsDto.prototype, "documentId", void 0);
class BrokingSlipFormDataCommentsDto {
}
exports.BrokingSlipFormDataCommentsDto = BrokingSlipFormDataCommentsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Risk Mitigation Features",
        example: "Fire alarm system",
    }),
    (0, class_validator_1.IsString)({ message: "risk mitigation feature must be a string." }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipFormDataCommentsDto.prototype, "riskMitigationFeatures", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Clauses", example: "Standard clauses apply" }),
    (0, class_validator_1.IsString)({ message: "clause must be a string." }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipFormDataCommentsDto.prototype, "clauses", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Insurer Remarks", example: "Insurer approved" }),
    (0, class_validator_1.IsString)({ message: "Insurer remarks must be a string." }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipFormDataCommentsDto.prototype, "insurerRemarks", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Remarks", example: "No additonal remarks" }),
    (0, class_validator_1.IsString)({ message: "remarks must be a string." }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipFormDataCommentsDto.prototype, "remarks", void 0);
class BrokingSlipFormDataDto {
}
exports.BrokingSlipFormDataDto = BrokingSlipFormDataDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "preferred TPA details",
        type: [PreferredTpaDetailsDto],
    }),
    (0, class_validator_1.IsArray)({ message: "preferred TPA details must be an array" }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => PreferredTpaDetailsDto),
    tslib_1.__metadata("design:type", Array)
], BrokingSlipFormDataDto.prototype, "preferredTPADetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Covers details",
        type: [PreferredInsurerDetailsDto],
    }),
    (0, class_validator_1.IsArray)({ message: "preferred Insurer details must be an array" }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => PreferredInsurerDetailsDto),
    tslib_1.__metadata("design:type", Array)
], BrokingSlipFormDataDto.prototype, "preferredInsurerDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Broking slip version form data",
        type: BrokingSlipFormDataCommentsDto,
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => BrokingSlipFormDataCommentsDto),
    tslib_1.__metadata("design:type", BrokingSlipFormDataCommentsDto)
], BrokingSlipFormDataDto.prototype, "others", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "preferred TPA details",
        type: [BrokingSlipDocumentsDto],
    }),
    (0, class_validator_1.IsArray)({ message: "preferred TPA details must be an array" }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => BrokingSlipDocumentsDto),
    tslib_1.__metadata("design:type", Array)
], BrokingSlipFormDataDto.prototype, "documents", void 0);
class BrokingSlipDataDto {
}
exports.BrokingSlipDataDto = BrokingSlipDataDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Opportunity activity Id", example: 100000 }),
    (0, class_validator_1.IsInt)({ message: "Document Type Lid must be a integer." }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipDataDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Status Lid", example: 1 }),
    (0, class_validator_1.IsInt)({ message: "Status Lid Id must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipDataDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsObject)({
        message: "default covers must be an object with cover IDs as keys",
    }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object)
], BrokingSlipDataDto.prototype, "defaultCovers", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Broking slip version form data",
        type: BrokingSlipFormDataDto,
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => BrokingSlipFormDataDto),
    tslib_1.__metadata("design:type", BrokingSlipFormDataDto)
], BrokingSlipDataDto.prototype, "formData", void 0);
